import { render, staticRenderFns } from "./liquidFeeder.vue?vue&type=template&id=ca0ea15e&scoped=true&"
import script from "./liquidFeeder.vue?vue&type=script&lang=js&"
export * from "./liquidFeeder.vue?vue&type=script&lang=js&"
import style0 from "./liquidFeeder.vue?vue&type=style&index=0&id=ca0ea15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ea15e",
  null
  
)

export default component.exports